import React, { useState, useEffect } from 'react';
import '../../App.css';
import '../loginPage/loginPager.css';
import logoImg from '../../images/carter-logo.svg';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { END_URL,RECAPTCHA_SITE_KEY } from '../../config';
import showEyeImg from '../../images/show-eye.svg';
import hideEyeImg from '../../images/hide-eye.svg';
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";

function LoginPage() {
  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [forgotPassword, setForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [dynamicContent, setDynamicContent] = useState(null);

  const [showLoginMethodModal, setShowLoginMethodModal] = useState(false);
  const [loginMethod, setLoginMethod] = useState(''); // 'otp' or '2fa'

  // New states for 2FA code entry inside modal
  const [isEntering2FA, setIsEntering2FA] = useState(false);
  const [twoFACode, setTwoFACode] = useState('');
  const [twoFAError, setTwoFAError] = useState('');


  const [isEnteringOTP, setIsEnteringOTP] = useState(false);
const [emailOTP, setEmailOTP] = useState('');
const [otpSendMessage, setOtpSendMessage] = useState('');
const [otpError, setOtpError] = useState('');

  const [showPassword, setShowPassword] = useState(false);

  const [captchaValue, setCaptchaValue] = useState(null);

  const [CaptchaError, setCaptchaError] = useState('');

  const [LoginContent, setLoginContent] = useState([]);



  const navigate = useNavigate();

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  // ...[forgot password handlers remain unchanged]...

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');

    try {
      const response = await axios.post(
        `${END_URL}login`,
        loginData,
        { headers: { 'Content-Type': 'application/json' } }
      );
      const token = response.data.token;
      const user = response.data.user;

      if (token) {
        sessionStorage.setItem('authToken', token);
        sessionStorage.setItem('user', JSON.stringify(user));
        
        if (user.isAuthy === 1) {
          setShowLoginMethodModal(true);
        } else {
          navigate('/dashboard');
        }
      }

      if (response.data.user?.status !== 'active') {
        setLoginError('Your account is inactive. Please contact the administrator.');
        sessionStorage.removeItem('authToken');
      }
    } catch (error) {
      console.error('Login failed', error.response?.data);
      setLoginError('Invalid credentials. Please try again.');
    }
  };


    useEffect(() => {
      const loginData = async () => {
        try {
          const response = await axios.get(
            `${END_URL}login_data`  
          );

          setLoginContent(response?.data?.login_data);

        } catch (error) {
          console.error('Failed to fetch countries:', error);
     
        }
      };

      loginData();
    }, []);

    const handleCaptchaChange = (value) => {

      setCaptchaValue(value);

    };


      const handleSubmit = (e) => {

        e.preventDefault();

        setCaptchaError("");

        if (!captchaValue) {

          setCaptchaError("Please complete the CAPTCHA verification.");

          return;
        }
        
        handleForgotPasswordSubmit(e); 
      };

      const handleForgotPasswordSubmit = async (e) => {
        e.preventDefault();

          setCaptchaError("");

          setResetMessage("");
        try {
           
            const response = await axios.post(
                `${END_URL}forgot-password`,{ email: resetEmail ,captcha: captchaValue  }, {
                headers: { "Content-Type": "application/json" },
            });

            setResetMessage('Password reset instructions have been sent to your email.');

        } catch (error) {

          const msg = error.response?.data?.error;

          if (msg === "Invalid captcha") {

            setCaptchaError("Captcha verification failed. Please try again.");
          } else {
            
            setResetMessage("Failed to send reset instructions. Please try again.");
          }

          console.error("Password reset failed", error.response?.data);
        }
    };



    


  // Show 2FA input immediately when method is changed to 2fa
const onLoginMethodChange = async (e) => {
  const method = e.target.value;
  setLoginMethod(method);
  setTwoFAError('');
  setOtpError('');
  setOtpSendMessage('');

  if (method === '2fa') {
    setIsEntering2FA(true);
    setIsEnteringOTP(false);
  } else if (method === 'otp') {
    setIsEnteringOTP(true);
    setIsEntering2FA(false);

    // Send OTP email immediately
    try {
      const token = sessionStorage.getItem('authToken');
      const res = await axios.get(`${END_URL}send2famail`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOtpSendMessage(res.data.message || 'OTP sent to your email.');
    } catch (err) {
      setOtpError('Failed to send OTP email.');
    }
  }
};


  // Submit 2FA code API call inside modal
  const handle2FASubmit = async (e) => {
    e.preventDefault();
    setTwoFAError('');

    if (twoFACode.length !== 6) {
      setTwoFAError('Please enter a valid 6-digit 2FA code.');
      return;
    }

    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.post(
        `${END_URL}verify2fa`,
        { code: twoFACode, type: '2fa' },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.verified) {
        setShowLoginMethodModal(false);
        navigate('/dashboard');
      } else {
        setTwoFAError('Invalid 2FA code. Please try again.');
      }
    } catch (error) {
      setTwoFAError(error.response?.data?.message || 'Verification failed.');
    }
  };

  // ...fetchDynamicContent useEffect and other code remain unchanged...

  const [isActive, setIsActive] = useState(false);

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  return (
    <section className="login-wrapp">
      <div className="container">
        <div className="login-box">
          <div className="login-col1">
            <Link className="navbar-brand" to="/">
              <img src={logoImg} alt="Logo" />
            </Link>
          </div>
          <div className="login-col2">
            {!forgotPassword ? (
              <>

                <span dangerouslySetInnerHTML={{ __html:LoginContent?.logincontent1 }}/>

                <form onSubmit={handleLoginSubmit}>
                  <div className="form-field">
                    <label>Email address</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="you@example.com"
                      className="form-control"
                      value={loginData.email}
                      onChange={handleLoginChange}
                    />
                  </div>
                  <div className="form-field">
                    <label>Password</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="••••••••"
                      className="form-control"
                      value={loginData.password}
                      onChange={handleLoginChange}
                    />
                    {showPassword ? (
                        <FaRegEye
                          onClick={() => setShowPassword(false)}
                          className="password-toggle-icon"
                          title="Hide password"
                        />
                      ) : (
                        <FaRegEyeSlash
                          onClick={() => setShowPassword(true)}
                          className="password-toggle-icon"
                          title="Show password"
                        />
                      )}
                  </div>
                  {loginError && <p className="error">{loginError}</p>}
                  <div className="checkbox1">
                    <input type="checkbox" />
                    <label htmlFor="">
                      Remember me
                    </label>
                  </div>
                  <p><a href="#" onClick={() => setForgotPassword(true)}>Forgot Password?</a></p>
                  <input type="submit" value="Secure Login" className="btn btn-primary" />

                  <p>Need an account? <a href="/registerPage">Register here</a> · Having trouble? <a href="/contact">Contact support</a></p>

                </form>
              </>
            ) : (
              <>
                <h2>Forgot your password ?</h2>
                <p>Enter your account email and we’ll send you a secure link to reset it.</p>
                <form onSubmit={handleSubmit}>
                  <div className="form-field">
                    <label>Email address</label>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      className="form-control"
                      value={resetEmail}
                      onChange={(e) => setResetEmail(e.target.value)}
                    />
                  </div>
                  {resetMessage && (
                    <p className={`message ${resetMessage.includes('Failed') ? 'error' : 'success'}`}>
                      {resetMessage}
                    </p>
                  )}
                  <input type="submit" value="Send reset link" className="btn btn-primary" />
                  <div className="hint-txt">
                    We limit requests to protect your account. You may be asked to complete a quick check.
                  </div>
                 
                    <div className="recaptcha-box" style={{ margin: "15px 0" }}>
                      <ReCAPTCHA
                        sitekey={RECAPTCHA_SITE_KEY}
                        onChange={handleCaptchaChange}
                      />
                    </div>

                    {CaptchaError && (
                        <div className="captch-txt-error">
                          
                          {CaptchaError}

                        </div>
                    )}

                  <p>Remembered your password? <a href="#" onClick={() => setForgotPassword(false)}>Back to Login</a></p>
                </form>
              </>
            )}
            {!forgotPassword && (
              <div dangerouslySetInnerHTML={{ __html: dynamicContent?.logincontent1 }} />
            )}
            {forgotPassword && (
              <div dangerouslySetInnerHTML={{ __html: dynamicContent?.forgotcontent1 }} />
            )}
          </div>
        </div>

        {showLoginMethodModal && (
          <div className="modal-overlay">
            <div className="modal-content select-login-modal">
              <h3>Select Login Method</h3>

              {/* Radio Buttons */}
              {!isEntering2FA && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (!loginMethod) {
                      alert('Please select a login method.');
                      return;
                    }
                    if (loginMethod === 'otp') {
                      navigate('/otp-verification');
                      setShowLoginMethodModal(false);
                    } else if (loginMethod === '2fa') {
                      setIsEntering2FA(true);
                    }
                  }}
                >
                  <div className="form-check">
                    <input
                      type="radio"
                      id="login_method_otp"
                      name="login_method"
                      value="otp"
                      onChange={onLoginMethodChange}
                    />
                    <label htmlFor="login_method_otp">Email OTP</label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="login_method_2fa"
                      name="login_method"
                      value="2fa"
                      onChange={onLoginMethodChange}
                    />
                    <label htmlFor="login_method_2fa">2FA Authenticator</label>
                  </div>
                  <button type="submit" className="btn btn-primary mt-3">
                    Continue
                  </button>
                </form>
              )}

              {/* 2FA Code Input */}
              {isEntering2FA && (
                <form onSubmit={handle2FASubmit}>
                  <div className="form-group mt-3">
                    <label htmlFor="twoFACode">Enter your authenticator code</label>
                    <input
                      type="text"
                      id="twoFACode"
                      value={twoFACode}
                      onChange={(e) => setTwoFACode(e.target.value)}
                      maxLength={6}
                      className="form-control"
                      placeholder="6-digit code"
                    />
                    {twoFAError && <small className="error text-danger">{twoFAError}</small>}
                  </div>
                  <button type="submit" className="btn btn-primary mt-2">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mt-2 ms-2"
                    onClick={() => {
                      setIsEntering2FA(false);
                      setLoginMethod('');
                      setTwoFAError('');
                      setTwoFACode('');
                    }}
                  >
                    Back
                  </button>
                </form>
              )}


  {isEnteringOTP && (
  <form onSubmit={async (e) => {
    e.preventDefault();
    setOtpError('');
    if (emailOTP.length !== 6) {
      setOtpError('Please enter a valid 6-digit OTP.');
      return;
    }

    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.post(`${END_URL}verify2fa`, 
        { code: emailOTP, type: 'email' }, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.verified) {
        setShowLoginMethodModal(false);
        navigate('/dashboard');
      } else {
        setOtpError('Invalid OTP, please try again.');
      }
    } catch (error) {
      setOtpError(error.response?.data?.message || 'OTP verification failed.');
    }
  }}>
    <div className="form-group mt-3">
      <label htmlFor="emailOTP">Enter your OTP</label>
      <input
        type="text"
        id="emailOTP"
        value={emailOTP}
        onChange={(e) => setEmailOTP(e.target.value)}
        maxLength={6}
        className="form-control"
        placeholder="6-digit code"
      />
      {otpError && <small className="error text-danger">{otpError}</small>}
      {otpSendMessage && <small className="text-success">{otpSendMessage}</small>}
    </div>
    <button type="submit" className="btn btn-primary mt-2">Verify OTP</button>
    <button
      type="button"
      className="btn btn-secondary mt-2 ms-2"
      onClick={() => {
        setIsEnteringOTP(false);
        setLoginMethod('');
        setOtpError('');
        setOtpSendMessage('');
        setEmailOTP('');
      }}
    >
      Back
    </button>
  </form>
)}




            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default LoginPage;
